
import type { Filter, HierarchicalFilter } from '@empathyco/x-types'
import { StaggeredFadeAndSlide } from '@empathyco/x-components'
import { SelectedFiltersList, SimpleFilter } from '@empathyco/x-components/facets'
import { defineComponent } from 'vue'

import { ColorEnum } from '../../../enums'

import { EpbBadge } from '../../shared/epb-badge'

export default defineComponent({
  name: 'XSelectedFiltersList',
  components: {
    EpbBadge,
    SelectedFiltersList,
    SimpleFilter,
  },
  setup(): Record<string, any> {
    const baseClass = 'epb-x-selected-filters-list'
    const showFilter = (filter: Filter): boolean => {
      if (filter.modelName === 'HierarchicalFilter') {
        const hierarchicalFilter = filter as HierarchicalFilter
        if (!hierarchicalFilter.children) {
          return true
        } else {
          return hierarchicalFilter.children.every(child => !child.selected)
        }
      }
      return filter.selected
    }

    return {
      animation: StaggeredFadeAndSlide,
      baseClass,
      ColorEnum,
      showFilter,
    }
  },
})
